import { Movement, MovementDataStore, movementSelectors } from '@skinsoft/entity';
import { Featured } from '@skinsoft/ui';
import { Observable, of } from 'rxjs';
import { catchError, merge } from 'rxjs/operators';

import { resolveAuthor } from '../../resolve-author';

export function toFeatured$(movement: Movement): Observable<Featured> {
    const featured: Featured = {
        author: movementSelectors.author(movement),
        date: movementSelectors.endDate(movement),
        description: movementSelectors.title(movement),
        headerDate: movementSelectors.startDate(movement),
        highlight: MovementDataStore.highlightStates.includes(movementSelectors.state(movement)),
        id: movement.id,
        state: movementSelectors.state(movement),
        stateLabel: `movement.state.${movementSelectors.state(movement)}`,
        title: movementSelectors.incrementalTitle(movement),
    };

    const featured$ = of(featured);

    return featured$.pipe(
        merge(of({ ...featured, author: null } as Featured), featured$.pipe(
            resolveAuthor,
        ) as Observable<Featured>),
        catchError(error => of({ ...featured, author: error })),
    );
}
